module.exports = __webpack_public_path__ + "img/icon(16).c55e6895.png";